// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
.contact {
  background: linear-gradient(90.21deg, var(--cyan) -5.91%, var(--dark-green) 111.58%);
  padding: 60px 0 200px 0;
}

.contact img {
  width: 92%;
}

.contact h2 {
  font-size: 45px;
  font-weight: 700;
  margin-bottom: 30px;
}

.contact form input,
.contact form textarea {
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 20px;
  color: #fff;
  margin: 0 0 8px 0;
  padding: 18px 26px;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.8px;
  transition: 0.3s ease-in-out;
}

.contact form input:focus,
.contact form textarea:focus {
  background: rgba(255, 255, 255, 1);
  color: #121212;
}
.contact form input::placeholder,
.contact form textarea::placeholder {
  font-size: 16px;
  font-weight: 400;
  color: #fff;
}

.contact form input:focus::placeholder,
.contact form textarea:focus::placeholder {
  color: #121212;
  opacity: 0.8;
}

.contact form button {
  font-weight: 700;
  color: #000;
  background-color: #fff;
  padding: 14px 48px;
  font-size: 18px;
  margin-top: 25px;
  border-radius: 0;
  position: relative;
  transition: 0.3s ease-in-out;
}

.contact form button span {
  z-index: 1;
  position: relative;
}

.contact form button:hover {
  color: #fff;
}

.contact form button::before {
  content: "";
  background: #121212;
  width: 0;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  transition: 0.3s ease-in-out;
}

.contact form button:hover::before {
  width: 100%;
}

.about-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition:
    z-index 0.3s step-end,
    top 0ms ease-in-out 300ms;
  z-index: -1000;
}

.about-modal .overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 100ms ease-in-out 200ms;
}

.about-modal .about-modal-content {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1.15);
  width: 95%;
  max-width: 350px;
  background: #fff;
  padding: 25px;
  opacity: 0;
  border-radius: 20px;
  box-shadow: 0 2px 2px 5px rgba(0, 0, 0, 0.05);
  transition: all 300ms ease-in-out;
}

.about-modal .about-modal-content h2 {
  margin: 10px 0;
  font-size: 25px;
  color: var(--dark-green);
  text-align: center;
}

.about-modal .about-modal-content p {
  margin: 15px 0;
  font-size: 16px;
  color: var(--dark-green);
}

.about-modal.active {
  top: 0;
  transition: top 0ms ease-in-out 0ms;
  z-index: 99999;
}
.about-modal.active .overlay {
  opacity: 1;
  transition: all 300ms ease-in-out;
}
.about-modal.active .about-modal-content {
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./packages/studytour-io-app/src/components/Contact.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,oFAAoF;EACpF,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;;EAEE,kCAAkC;EAClC,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;6BAE2B;EAC3B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,4CAA4C;EAC5C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,6CAA6C;EAC7C,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,MAAM;EACN,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,UAAU;EACV,iCAAiC;AACnC;AACA;EACE,yCAAyC;EACzC,UAAU;AACZ","sourcesContent":["/**\n * Copyright 2025 Paion Data. All rights reserved.\n */\n.contact {\n  background: linear-gradient(90.21deg, var(--cyan) -5.91%, var(--dark-green) 111.58%);\n  padding: 60px 0 200px 0;\n}\n\n.contact img {\n  width: 92%;\n}\n\n.contact h2 {\n  font-size: 45px;\n  font-weight: 700;\n  margin-bottom: 30px;\n}\n\n.contact form input,\n.contact form textarea {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  border-radius: 20px;\n  color: #fff;\n  margin: 0 0 8px 0;\n  padding: 18px 26px;\n  font-weight: 500;\n  font-size: 18px;\n  letter-spacing: 0.8px;\n  transition: 0.3s ease-in-out;\n}\n\n.contact form input:focus,\n.contact form textarea:focus {\n  background: rgba(255, 255, 255, 1);\n  color: #121212;\n}\n.contact form input::placeholder,\n.contact form textarea::placeholder {\n  font-size: 16px;\n  font-weight: 400;\n  color: #fff;\n}\n\n.contact form input:focus::placeholder,\n.contact form textarea:focus::placeholder {\n  color: #121212;\n  opacity: 0.8;\n}\n\n.contact form button {\n  font-weight: 700;\n  color: #000;\n  background-color: #fff;\n  padding: 14px 48px;\n  font-size: 18px;\n  margin-top: 25px;\n  border-radius: 0;\n  position: relative;\n  transition: 0.3s ease-in-out;\n}\n\n.contact form button span {\n  z-index: 1;\n  position: relative;\n}\n\n.contact form button:hover {\n  color: #fff;\n}\n\n.contact form button::before {\n  content: \"\";\n  background: #121212;\n  width: 0;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 0;\n  transition: 0.3s ease-in-out;\n}\n\n.contact form button:hover::before {\n  width: 100%;\n}\n\n.about-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  transition:\n    z-index 0.3s step-end,\n    top 0ms ease-in-out 300ms;\n  z-index: -1000;\n}\n\n.about-modal .overlay {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  opacity: 0;\n  transition: opacity 100ms ease-in-out 200ms;\n}\n\n.about-modal .about-modal-content {\n  position: absolute;\n  top: 30%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(1.15);\n  width: 95%;\n  max-width: 350px;\n  background: #fff;\n  padding: 25px;\n  opacity: 0;\n  border-radius: 20px;\n  box-shadow: 0 2px 2px 5px rgba(0, 0, 0, 0.05);\n  transition: all 300ms ease-in-out;\n}\n\n.about-modal .about-modal-content h2 {\n  margin: 10px 0;\n  font-size: 25px;\n  color: var(--dark-green);\n  text-align: center;\n}\n\n.about-modal .about-modal-content p {\n  margin: 15px 0;\n  font-size: 16px;\n  color: var(--dark-green);\n}\n\n.about-modal.active {\n  top: 0;\n  transition: top 0ms ease-in-out 0ms;\n  z-index: 99999;\n}\n.about-modal.active .overlay {\n  opacity: 1;\n  transition: all 300ms ease-in-out;\n}\n.about-modal.active .about-modal-content {\n  transform: translate(-50%, -50%) scale(1);\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
